const elaReadingSkillsMapping = {
  "Main Idea": "Main Idea",
  "Key Details": "Main Idea",
  Summarization: "Main Idea",
};

export default elaReadingSkillsMapping;
